export const generateColorCampaign = (() => {
  const colorPalette = [
    "#6200EE",
    "#C8A1FF",
    "#2ECC71",
    "#F1C40F",
    "#3498DB",
    "#E67E22",
    "#1ABC9C",
    "#9B59B6",
    "#00BCD4",
    "#4CAF50",
    "#FFC107",
    "#FF5722",
    "#9E9E9E",
    "#607D8B",
    "#3F51B5",
    "#8BC34A",
    "#FF9800",
    "#FF4081",
    "#9C27B0",
    "#673AB7",
    "#2196F3",
    "#03A9F4",
    "#8BC34A",
    "#CDDC39",
    "#FFEB3B",
    "#FFC107",
    "#FF9800",
    "#FF5722",
    "#795548",
  ];
  const cache: Record<string, string> = {};
  return (source: string) => {
    if (!cache[source]) {
      const index = Object.keys(cache).length % colorPalette.length;
      cache[source] = colorPalette[index];
    }
    return cache[source];
  };
})();

export const generateColorAdGroup = (() => {
  const colorPalette = [
    "#6200EE",
    "#C8A1FF",
    "#2ECC71",
    "#F1C40F",
    "#3498DB",
    "#E67E22",
    "#1ABC9C",
    "#9B59B6",
    "#00BCD4",
    "#4CAF50",
    "#FFC107",
    "#FF5722",
    "#9E9E9E",
    "#607D8B",
    "#3F51B5",
    "#8BC34A",
    "#FF9800",
    "#FF4081",
    "#9C27B0",
    "#673AB7",
    "#2196F3",
    "#03A9F4",
    "#8BC34A",
    "#CDDC39",
    "#FFEB3B",
    "#FFC107",
    "#FF9800",
    "#FF5722",
    "#795548",
  ];
  const cache: Record<string, string> = {};
  return (source: string) => {
    if (!cache[source]) {
      const index = Object.keys(cache).length % colorPalette.length;
      cache[source] = colorPalette[index];
    }
    return cache[source];
  };
})();
